import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import store from "./store/Store";
import router from "./router/Router";
import "./assets/scss/style.scss";
import App from "./App.vue";
import VueFeather from "vue-feather";
import InstantSearch from "vue-instantsearch";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import VueCurrencyInput from "vue-currency-input";
// i18n
import i18n from "./i18n/i18n.js";
import "vue-hljs/dist/style.css";
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import Tabela from "@/components/tabelas/Tabela.vue";
import TabelaPadrao from "@/components/tabelas/TabelaPadrao.vue";
import TabelaAcoesPadrao from "@/components/tabelas/TabelaAcoes.vue";
import ModalPadrao from "@/components/modal/ModalPadrao.vue";
import FiltroEmpresas from "@/components/filtros/FiltroEmpresas.vue";
// import {VueReCaptcha} from 'vue-recaptcha-v3';

Vue.component('b-tabela', Tabela);
Vue.component('tabela-padrao', TabelaPadrao);
Vue.component('tabela-padrao-acoes', TabelaAcoesPadrao);
Vue.component('modal-padrao', ModalPadrao);
Vue.component('filtro-empresas', FiltroEmpresas);

import { AlertasMixin } from "@/common/mixins/AlertasMixin"
import { FormMixin } from '@/common/mixins/FormMixin';
Vue.mixin(AlertasMixin);
Vue.mixin(FormMixin);

Vue.use(Donut);

Vue.use(VueFeather);

Vue.config.productionTip = false;

import vueHljs from "vue-hljs";
import hljs from "highlight.js";

//use
Vue.use(vueHljs, { hljs });
Vue.use(InstantSearch);
Vue.use(VueCurrencyInput);
Vue.use(VueTheMask);
Vue.use(money, { precision: 4 });

// Vue.use(VueReCaptcha, {
//   siteKey: '6Ld1DXYqAAAAAEF8JQ6WS5Bo2inSd033HDm6hW1e'
// })

new Vue({router, store,i18n, render: (h) => h(App)}).$mount('#app');

String.prototype.formatUnicorn =
  String.prototype.formatUnicorn ||
  function() {
    "use strict";
    var str = this.toString();
    if (arguments.length) {
      var t = typeof arguments[0];
      var key;
      var args = "string" === t || "number" === t ? Array.prototype.slice.call(arguments) : arguments[0];

      for (key in args) {
        str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
      }
    }

    return str;
  };
